<template>
  <div class="p-4 space-y-2">
    <div class="flex items-center justify-between mb-2">
      <h3 class="text-xs font-semibold text-gray-800">Sources</h3>
      <button class="text-xs px-3 py-1.5 rounded bg-gray-900 text-white hover:bg-gray-800" @click="openNew">+ New</button>
    </div>

    <LoadingIndicator v-if="loading.configs" message="Loading…" />
    <div v-else-if="!sourceConfigs.length" class="text-xs text-gray-400 text-center py-6">No source configs yet</div>
    <div v-else class="space-y-1.5">
      <div
        v-for="s in sourceConfigs"
        :key="s.id"
        class="px-3 py-2 border border-gray-200 rounded hover:bg-gray-50 cursor-pointer"
        @click="openEdit(s)"
      >
        <div class="text-xs font-medium text-gray-800 flex items-center gap-1.5">
          <span class="text-[10px] font-mono text-gray-400">#{{ s.id }}</span>
          {{ s.name }}
          <span class="text-[10px] px-1 py-0.5 rounded bg-blue-50 text-blue-700 font-mono">{{ s.source_class }}</span>
          <span
            v-if="s.delivery_mode === 'queryable_table'"
            class="text-[10px] px-1 py-0.5 rounded bg-orange-50 text-orange-700 font-mono"
          >queryable</span>
          <span v-if="!s.required" class="text-[10px] px-1 py-0.5 rounded bg-amber-50 text-amber-700">optional</span>
        </div>
        <div v-if="s.description" class="text-[10px] text-gray-500 mt-0.5">{{ s.description }}</div>
      </div>
    </div>

    <div class="mt-6 pt-4 border-t border-gray-100">
      <h4 class="text-[10px] font-semibold uppercase tracking-wider text-gray-400 mb-2">Registered Source Classes (read-only)</h4>
      <LoadingIndicator v-if="loading.registry" message="Loading registry…" />
      <div v-else class="space-y-1.5">
        <div v-for="cls in registry" :key="cls.name" class="px-3 py-2 border border-gray-200 rounded bg-gray-50">
          <div class="text-xs font-medium text-gray-800 flex items-center gap-1.5 font-mono">
            {{ cls.name }}
            <span v-if="cls.cacheable" class="text-[10px] px-1 py-0.5 rounded bg-purple-50 text-purple-700">cacheable</span>
            <span
              v-for="mode in (cls.supported_delivery_modes || ['inline_data'])"
              :key="mode"
              class="text-[10px] px-1 py-0.5 rounded font-normal"
              :class="mode === 'queryable_table' ? 'bg-orange-50 text-orange-700' : 'bg-gray-100 text-gray-600'"
            >{{ mode }}</span>
          </div>
          <div v-if="cls.description" class="text-[10px] text-gray-500 mt-0.5">{{ cls.description }}</div>
        </div>
      </div>
    </div>

    <SourceConfigModal
      v-if="showModal"
      :initial="editing"
      :source-classes="registry"
      @close="showModal = false"
      @saved="onSaved"
    />
  </div>
</template>

<script>
import axios from 'axios'
import LoadingIndicator from '@/components/widgetcomponents/library/LoadingIndicator.vue'
import SourceConfigModal from './SourceConfigModal.vue'

const API_BASE = 'api/intelligence/'

export default {
  name: 'SourceConfigsView',
  components: { LoadingIndicator, SourceConfigModal },

  data() {
    return {
      sourceConfigs: [],
      registry: [],
      loading: { configs: true, registry: true },
      showModal: false,
      editing: {},
    }
  },

  methods: {
    async fetchAll() {
      try {
        const [scRes, regRes] = await Promise.all([
          axios.get(`${API_BASE}source-configs/`),
          axios.get(`${API_BASE}registry/`),
        ])
        this.sourceConfigs = scRes.data.results || scRes.data
        this.registry = regRes.data.source_classes || []
      } catch (e) {
        console.error('SourceConfigsView load failed:', e)
      } finally {
        this.loading = { configs: false, registry: false }
      }
    },
    openNew() { this.editing = {}; this.showModal = true },
    openEdit(s) { this.editing = s; this.showModal = true },
    onSaved() { this.showModal = false; this.fetchAll() },
  },

  mounted() { this.fetchAll() },
}
</script>
